export { default as createGoTo } from "./createGoTo";



// WEBPACK FOOTER //
// ./src/model/subsystems/app/actions/router/index.js